import CCTPatientHistory from './CCTPatientHistory';

export default CCTPatientHistory;



// WEBPACK FOOTER //
// ./src/views/components/CCTPatientHistory/index.js